import { authVerificationApi } from '@/api';
export default {
    async requestAuthVerification({ phone }) {
        const data = {
            phone,
        };
        const response = await authVerificationApi.postRequestAuthVerification(data);
        return response.data;
    },
    async checkAuthVerification({ authId, authCode }) {
        const data = {
            authId,
            authCode,
        };
        const response = await authVerificationApi.postCheckAuthVerification(data);
        return response.data;
    },
};
